import { setListMessage } from './../../../../config/redux/alerts/alertsActions';
import { toggleOrderPanel } from './../../../../config/redux/orders/ordersPanel/orderPanelActions';
import { useSelector, RootStateOrAny, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { generateItems } from "../../actions/generateCommands/orders/generateOrderPanelCommands";
import {
  toggleOrderAccept,
  addOrderComment,
  reloadOrders
} from "../../../../config/redux/orders/ordersActions";
import {acceptRaport, cancelOrder} from "../../../../connectors/orders/connectors/index";
import { setOrderEditing } from "../../../../config/redux/orders/ordersPanel/orderPanelActions";

export const useOrderPanelCommandBar = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const state = useSelector((state: RootStateOrAny) => state.orders);
  const {activeTab, editing} = useSelector((state: RootStateOrAny) => state.orderPanel);
  const { selectedOrders } = state;

  const addComment = () => {
      dispatch(addOrderComment(true)); 
  };

  const setOrderAccepted = async () => {
    try {
      await acceptRaport(selectedOrders[0].id);
      dispatch(toggleOrderAccept(true));
      dispatch(toggleOrderPanel(false))
      dispatch(setListMessage("Operacja przebiegła pomyślnie"))
    } catch(err) {
      console.error(err);
    }
  };
  

  const setOrderCanceled = async () => {
    await cancelOrder(selectedOrders[0].id)
        .then((response: any) => {
          dispatch(toggleOrderAccept(true));
          dispatch(reloadOrders(true));
        })
        .catch((error: any) => {
          console.error(error);
          // alert("ERRROR 72");
        });
  };

  const setEditing = () => {
    dispatch(setOrderEditing(true))
  }

  const actions = {
    addComment,
    setOrderAccepted,
    setOrderCanceled,
    setEditing,
  };

  const items = selectedOrders[0]
    ? generateItems(state, location.pathname, actions, activeTab, editing)
    : [];

  return {
    items,
  };
};